import React from 'react';
import { Grid } from '@mui/material';
import VoteCard from './VoteCard';

export interface LatestVoteItem {
  congress?: number;
  updateDate?: string;
  startDate?: string;
  voteDate?: string;
  voteType?: string;
  voteQuestion?: string;
  result?: string; // Passed / Failed / etc.
  rollCallNumber?: string | number;
  legislationType?: string; // e.g., HR, S, HRES
  legislationNumber?: string | number; // e.g., 3425
}

export interface LatestVotesCardListProps {
  items: LatestVoteItem[];
}

function coalesceDate(item: LatestVoteItem): string {
  return item.updateDate || item.voteDate || item.startDate || '';
}

function toBillUrl(item: LatestVoteItem): string | undefined {
  const t = (item.legislationType || '').toString();
  const n = (item.legislationNumber ?? '').toString();
  const c = item.congress;
  if (!t || !n || !c) return undefined;
  return `/bills/${c}/${t.toLowerCase()}/${n}`;
}

function toBillId(item: LatestVoteItem): string {
  const t = (item.legislationType || '').toString().toUpperCase();
  const n = (item.legislationNumber ?? '').toString();
  const fallback = item.voteQuestion ? item.voteQuestion : '—';
  return t && n ? `${t} ${n}` : fallback;
}

const LatestVotesCardList: React.FC<LatestVotesCardListProps> = ({ items }) => {
  const votes = Array.isArray(items) ? items.slice() : [];

  // Sort newest-first by the best available date field
  votes.sort((a, b) => {
    const ta = new Date(coalesceDate(a)).getTime();
    const tb = new Date(coalesceDate(b)).getTime();
    if (!isFinite(ta) && !isFinite(tb)) return 0;
    if (!isFinite(ta)) return 1;
    if (!isFinite(tb)) return -1;
    return tb - ta; // desc
  });

  return (
    <Grid container spacing={2}>
      {votes.map((v, idx) => (
        <Grid item xs={12} lg={6} key={idx}>
          <VoteCard
            date={coalesceDate(v)}
            billId={toBillId(v)}
            voteType={v.voteType || ''}
            result={v.result || ''}
            rollCall={v.rollCallNumber?.toString()}
            billUrl={toBillUrl(v)}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default LatestVotesCardList;
